// extracted by mini-css-extract-plugin
export default {"main-content":"DescriptionTerm_main-content__K1uw-","descriptionTerm":"DescriptionTerm_descriptionTerm__XVudt","compact":"DescriptionTerm_compact__DJSyb"};